import React from 'react';
import './css/index.scss';
import { useSelector } from 'react-redux';
import TableCell from '../../../../components/TableCell';
import RefreshIcon from '../../../../assets/formIcons/refresh.svg';
import TableRow from '../../../../components/TableRow';
import { USER_MODAL_STATES } from '../../constants';
import avatarIcon from '../../../../assets/formIcons/avatar.svg';
import DotsIcon from '../../../../assets/formIcons/dots.svg';
import useComponentVisible from '../../../../helpers/hooks/useComponentVisible';
import BlockIcon from '../../../../assets/formIcons/block.svg';
import DeleteIcon from '../../../../assets/formIcons/delete.svg';
import {
  formatLanguageDisplayName,
  getInterfaceLanguageLabel,
} from '../../../../helpers/interfaceLanguages';

function formatInterfaceLanguages(codes = []) {
  if (!codes?.length) return '—';
  return codes.map((code) => getInterfaceLanguageLabel(code)).join(', ');
}

function formatContentLanguages(languages = []) {
  if (!languages?.length) return '—';
  return languages
    .map((lang) => (typeof lang === 'string' ? getInterfaceLanguageLabel(lang) : formatLanguageDisplayName(lang)))
    .join(', ');
}

function UserItem({
  item, itemsPassed, widths, index, setSelectedUser, setModalState, setIsModalVisible,
}) {
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
  const { profile } = useSelector((store) => store.account);

  const onPopupItemClick = (state) => () => {
    setSelectedUser(item);
    setModalState(state);
    setIsModalVisible(true);
    setIsComponentVisible(false);
  };

  return (
    <TableRow key={item._id} dashed={!item.is_active}>
      <TableCell width={widths[0]}>
        <div className="user_item_index">
          {itemsPassed + index + 1}
          <img src={avatarIcon} alt="Avatar" />
        </div>
      </TableCell>
      <TableCell width={widths[1]}>
        {item.display_name}
        {item.display_name === 'Unnamed User' ? ' (не удалять!)' : ''}
      </TableCell>
      <TableCell width={widths[2]}>{item._id}</TableCell>
      <TableCell width={widths[3]}>{item.email}</TableCell>
      <TableCell width={widths[4]}>
        <span title={formatInterfaceLanguages(item.interface_languages)}>
          {formatInterfaceLanguages(item.interface_languages)}
        </span>
      </TableCell>
      <TableCell width={widths[5]}>
        <span title={formatContentLanguages(item.content_languages)}>
          {formatContentLanguages(item.content_languages)}
        </span>
      </TableCell>
      <TableCell
        width={widths[6]}
        isIcon
        onClick={() => setIsComponentVisible(true)}
      >
        <img src={DotsIcon} alt="" />
      </TableCell>

      <div ref={ref} className={`table_popup ${isComponentVisible && 'visible'}`}>
        {profile?.access_codes?.includes('modifyUsersAndOrgs')
          ? item.is_active ? (
            <div className="table_popup_item" onClick={onPopupItemClick(USER_MODAL_STATES.block)}>
              <img src={BlockIcon} alt="" />
              <p>Забанить пользователя</p>
            </div>
          ) : (
            <div
              className="table_popup_item"
              onClick={onPopupItemClick(USER_MODAL_STATES.makeActive)}
            >
              <img src={RefreshIcon} alt="" />
              <p>Разбанить пользователя</p>
            </div>
          ) : null}

        {profile?.access_codes?.includes('canFullyDelete') && (
          <div className="table_popup_item" onClick={onPopupItemClick(USER_MODAL_STATES.fullyDelete)}>
            <img src={DeleteIcon} alt="" />
            <p>Удалить полностью</p>
          </div>
        )}
      </div>

    </TableRow>
  );
}

export default UserItem;
